import { useAppSelector } from '@application/store/useStore';
export function useBrokerCount() {
    const brokers = useAppSelector((state) => state.broker.brokers);
    return brokers?.length ?? 0;
}
